import { Fragment } from 'react';
import { Route } from 'react-router-dom';

import Banner from 'components/Banner';
import Head from 'components/Head';

const AppContent = (
  {
    Page,
    path,
    exact = false,
    withBanner = false,
    title,
    description,
    location,
  },
  key
) => (
  <Route path={path} key={key} exact={exact}>
    <Fragment>
      {title && <Head title={title} description={description} />}
      <Page location={location} />
      {withBanner && <Banner />}
    </Fragment>
  </Route>
);

export default AppContent;
